"use strict";

var _regeneratorRuntime = require("/home/nftfrontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hmacSha512Verify = exports.hmacSha512Sign = exports.hmacSha256Verify = exports.hmacSha256Sign = void 0;

var helpers_1 = require("../helpers");

function hmacSha256Sign(key, msg) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!helpers_1.isBrowser()) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return helpers_1.browserHmacSha256Sign(key, msg);

          case 3:
            result = _context.sent;
            _context.next = 7;
            break;

          case 6:
            if (helpers_1.isNode()) {
              result = helpers_1.nodeHmacSha256Sign(key, msg);
            } else {
              result = helpers_1.fallbackHmacSha256Sign(key, msg);
            }

          case 7:
            return _context.abrupt("return", result);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

exports.hmacSha256Sign = hmacSha256Sign;

function hmacSha256Verify(key, msg, sig) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var result, expectedSig, _expectedSig, _expectedSig2;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!helpers_1.isBrowser()) {
              _context2.next = 7;
              break;
            }

            _context2.next = 3;
            return helpers_1.browserHmacSha256Sign(key, msg);

          case 3:
            expectedSig = _context2.sent;
            result = helpers_1.isConstantTime(expectedSig, sig);
            _context2.next = 8;
            break;

          case 7:
            if (helpers_1.isNode()) {
              _expectedSig = helpers_1.nodeHmacSha256Sign(key, msg);
              result = helpers_1.isConstantTime(_expectedSig, sig);
            } else {
              _expectedSig2 = helpers_1.fallbackHmacSha256Sign(key, msg);
              result = helpers_1.isConstantTime(_expectedSig2, sig);
            }

          case 8:
            return _context2.abrupt("return", result);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.hmacSha256Verify = hmacSha256Verify;

function hmacSha512Sign(key, msg) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!helpers_1.isBrowser()) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return helpers_1.browserHmacSha512Sign(key, msg);

          case 3:
            result = _context3.sent;
            _context3.next = 7;
            break;

          case 6:
            if (helpers_1.isNode()) {
              result = helpers_1.nodeHmacSha512Sign(key, msg);
            } else {
              result = helpers_1.fallbackHmacSha512Sign(key, msg);
            }

          case 7:
            return _context3.abrupt("return", result);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

exports.hmacSha512Sign = hmacSha512Sign;

function hmacSha512Verify(key, msg, sig) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var result, expectedSig, _expectedSig3;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (helpers_1.isNode()) {
              expectedSig = helpers_1.nodeHmacSha512Sign(key, msg);
              result = helpers_1.isConstantTime(expectedSig, sig);
            } else {
              _expectedSig3 = helpers_1.fallbackHmacSha512Sign(key, msg);
              result = helpers_1.isConstantTime(_expectedSig3, sig);
            }

            return _context4.abrupt("return", result);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}

exports.hmacSha512Verify = hmacSha512Verify;